import React from "react";
import { Box } from "@mui/material";
import OwnerProjectsPage from "./OwnerProjectsPage";

/*
 * WP-STANDARD | OWNER UNIFIED PEOPLE / PROJECTS
 * Status: IMPLEMENTED · STATIC_PENDING · RUNTIME_PENDING
 *
 * The old Clients vs Projects switch was a duplicate mental model. OwnerClient remains
 * the identity/contact record in persistence, but the workspace exposes a single surface:
 * one person card with one-or-many projects underneath it. Every person is guaranteed at
 * least one base project by the backend invariant PERSON-PROJECT-001.
 */
export default function OwnerCrmPage() {
  return <Box sx={{ width: "100%", minHeight: 0 }}><OwnerProjectsPage /></Box>;
}
